import { render, staticRenderFns } from "./stacktrace_entry.vue?vue&type=template&id=13f854d4&"
import script from "./stacktrace_entry.vue?vue&type=script&lang=js&"
export * from "./stacktrace_entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports